import Request from '../Request';

/**
 * @class
 * Classe "abstrata" para implementação de processamentos
 * envolvendo dados do banco.
 * @extends Request
 */
export default class Handler extends Request { }
